




import { Component, Mixins } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import MyAddressList from "@/views/Mine/MoreServices/Address/MyAddressList.vue";

@Component({
  components: {
    MyAddressList,
  },
})
export default class ExternalAddressPage extends Mixins(Mixin) {}
